import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { TRANSITION_ANALYSIS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { ModelPortfoliosService } from 'ModelPortfolioApp/ts/shared/services/model-portfolios.service';
import * as i0 from "@angular/core";
import * as i1 from "ModelPortfolioApp/ts/shared/services/model-portfolios.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
export class SelectTransitionAnalysisBaseDirective {
    constructor(modelPortfoliosService, featureService) {
        this.modelPortfoliosService = modelPortfoliosService;
        this.featureService = featureService;
        this.transitionAnalysisList = [];
        this.nameFilterInput = new FormControl('', { nonNullable: true });
        this.filteredTransitionAnalysisList = [];
        this.sortColumn = 'analysis_name';
        this.sortDirection = DESC;
        this.modalOpen = false;
        this.title = 'Select Transition Analysis';
        this.showSelection = false;
    }
    ngOnInit() {
        if (this.featureService.userHasFeatures([TRANSITION_ANALYSIS_FEATURE])) {
            this.modelPortfoliosService.getTransitionAnalysisList().subscribe({
                next: (response) => {
                    this.transitionAnalysisList = response;
                    this.setTableSortProperties('analysis_name');
                },
            });
        }
        this.nameFilterSubscription = this.nameFilterInput.valueChanges
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe(() => this.filterTransitionAnalysisList());
    }
    ngOnDestroy() {
        this.nameFilterSubscription.unsubscribe();
    }
    filterTransitionAnalysisList() {
        const searchTerm = this.nameFilterInput.value.toLowerCase();
        if (!searchTerm) {
            this.filteredTransitionAnalysisList = this.transitionAnalysisList;
        }
        else {
            this.filteredTransitionAnalysisList = this.transitionAnalysisList.filter((analysis) => this.getTitle(analysis).toLowerCase().includes(searchTerm));
        }
    }
    closeModal() {
        this.modalOpen = false;
    }
    getSortNgClass(columnName) {
        if (columnName === this.sortColumn) {
            if (this.sortDirection === DESC)
                return 'th-sort-desc';
            if (this.sortDirection === ASC)
                return 'th-sort-asc';
        }
        return '';
    }
    /**
     * Sets sort column and sort direction when a column header is clicked
     * @param columnName: New sort column name.
     */
    setTableSortProperties(columnName) {
        if (columnName === this.sortColumn) {
            this.sortDirection = this.sortDirection === ASC ? DESC : ASC;
        }
        else {
            this.sortColumn = columnName;
            this.sortDirection = ASC;
        }
        const asc_or_desc = this.sortDirection === ASC ? 1 : -1;
        this.transitionAnalysisList.sort((a, b) => {
            if (this.sortColumn === 'analysis_name') {
                const nameA = this.getTitle(a);
                const nameB = this.getTitle(b);
                if (nameA < nameB)
                    return -1 * asc_or_desc;
                if (nameA > nameB)
                    return asc_or_desc;
                return 0;
            }
            if (a.createdDate < b.createdDate)
                return -1 * asc_or_desc;
            if (a.createdDate > b.createdDate)
                return asc_or_desc;
            return 0;
        });
        this.filterTransitionAnalysisList();
    }
    getTitle(analysis) {
        if (analysis === undefined || analysis === null) {
            return 'Select Transition Analysis';
        }
        if (analysis.targetPortfolio === '') {
            return `${analysis.transition_strategy}: ${analysis.initialPortfolio} grouped by ${analysis.groupType}`;
        }
        return `${analysis.transition_strategy}: ${analysis.initialPortfolio} to ${analysis.targetPortfolio}`;
    }
    exitModalHandler() {
        this.closeModal();
    }
}
SelectTransitionAnalysisBaseDirective.ɵfac = function SelectTransitionAnalysisBaseDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectTransitionAnalysisBaseDirective)(i0.ɵɵdirectiveInject(i1.ModelPortfoliosService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
SelectTransitionAnalysisBaseDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: SelectTransitionAnalysisBaseDirective });
